import { useIntl } from 'react-intl';

import { Text } from '@calm-web/design-system';

import messages from '@/components/emotion-detector/messages';
import { useEmotionRecommendations } from '@/hooks/emotion-detector';

import EmptyStateComponent from './components/EmptyStateComponent';
import LoadingState from './components/LoadingState';
import RecommendationsList from './components/RecommendationsList';
import {
	DescriptionText,
	RecommendationsContainer,
	RecommendationsHeader,
	StyledRecommendationsCard,
} from './styles';

interface EmotionRecommendationsProps {
	emotionRecommendations: ReturnType<typeof useEmotionRecommendations>;
	isVisible: boolean;
}

export default function EmotionRecommendations({
	emotionRecommendations,
	isVisible,
}: EmotionRecommendationsProps) {
	const { formatMessage } = useIntl();
	const { recommendationPack, searchLoading, handleContentClick } = emotionRecommendations;

	if (!isVisible) return null;

	const hasRecommendations = recommendationPack && recommendationPack.items.length > 0;

	return (
		<StyledRecommendationsCard data-card="recommendations">
			<RecommendationsContainer>
				<RecommendationsHeader>
					<Text el="h2">{formatMessage(messages.cameraRecommendationsTitle)}</Text>
					<DescriptionText>
						<Text el="p" color="gray6">
							{formatMessage(messages.cameraRecommendationsDescription)}
						</Text>
					</DescriptionText>
				</RecommendationsHeader>

				{searchLoading && <LoadingState />}
				{!searchLoading && hasRecommendations && (
					<RecommendationsList recommendationPack={recommendationPack} onContentClick={handleContentClick} />
				)}
				{!searchLoading && !hasRecommendations && <EmptyStateComponent />}
			</RecommendationsContainer>
		</StyledRecommendationsCard>
	);
}
